import styles from './_levelUpModal.module.scss'

interface LevelUpShieldProps {
  level: number
  part: 'outer' | 'inner'
}

const SHIELD_VIEWBOX = '370 290 650 720'

const OUTER_PATH =
  'M702.497 1002.44C405.292 933.101 370.712 606.108 390.573 451.278C536.371 417.263 659.272 332.569 702.497 294.474V1002.44ZM702.503 294.474C745.729 332.569 868.629 417.263 1014.43 451.278C1034.29 606.108 999.708 933.101 702.503 1002.44V294.474Z'

const INNER_PATH =
  'M702.499 836.913C544.27 799.998 525.859 625.91 536.433 543.48C614.055 525.371 679.486 480.282 702.499 460V836.913ZM702.501 460C725.514 480.282 790.946 525.371 868.568 543.48C879.141 625.91 860.73 799.998 702.501 836.913V460Z'

const LevelUpShield: React.FC<LevelUpShieldProps> = ({ level, part }) => (
  <div className={styles.shieldStack} aria-hidden>
    <svg
      className={styles.shieldSvg}
      viewBox={SHIELD_VIEWBOX}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {part === 'outer' ? (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d={OUTER_PATH}
          fill="white"
          fillOpacity="0.57"
        />
      ) : (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d={INNER_PATH}
          fill="#7479DC"
        />
      )}
    </svg>
    {part === 'inner' && <span className={styles.shieldLevel}>{level}</span>}
  </div>
)

export default LevelUpShield
